import { render } from "./HistoricalDataBooks.vue?vue&type=template&id=9202e076&scoped=true"
import script from "./HistoricalDataBooks.vue?vue&type=script&lang=js"
export * from "./HistoricalDataBooks.vue?vue&type=script&lang=js"

import "./HistoricalDataBooks.vue?vue&type=style&index=0&id=9202e076&lang=scss&scoped=true"

import exportComponent from "C:\\BT5DT1\\REPORT-WEB\\client\\databook\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9202e076"]])

export default __exports__